import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
  data: null,
  loading: false,
  error: null,
  addStatus: null,
  totalSubs: null,
  activeSubs: null,
  deactiveSubs: null,
  activeSubs: null,
  thisMonthStartSubs: null,
  UpdateId: null
};

export const GetSubscription = createAsyncThunk(
  "GetSubscription",
  async (body) => {
    try {
      const response = await instance.get(
        `/remark/subscription/subscription-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}&packageStatus=${body?.packageStatus}&packagetype=${body?.packagetype}`
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const UpdateSubscriptionStatus = createAsyncThunk(
  "UpdateStatusSubscription",
  async (data) => {
    try {
      const response = await instance.post(
        `remark/subscription/update-subscription-status?sub_id=${data.sub_id}`,
        { "buy_sub_status": data?.buy_sub_status })
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateSubscriptionId = createAsyncThunk(
  "UpdateSubscriptionId",
  async (data) => {
    try {

      const response = await instance.post(
        `remark/subscription/update-payment_order_id?sub_id=${data.sub_id}`,
        {
          buy_sub_order_id: data?.buy_sub_order_id,
          buy_sub_payment_id: data?.buy_sub_payment_id,
        }
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


// export const GetSubscriptionInvoice = createAsyncThunk("GetSubscriptionInvoice", async (body) => {
//   try {
//     const response = await instance.get(
//       `/remark/subscription/subscription-list?page=${body.page}&search=${body.search}`
//     );
//     return response?.data;
//   } catch (error) {
//     throw error;
//   }
// });

export const SubscriptionSlice = createSlice({
  name: "SubscriptionSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetSubscription.pending, (state, action) => {
      state.loading = true;

    });
    builder.addCase(GetSubscription.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.totalSubs = action.payload?.totalSubs;
      state.deactiveSubs = action.payload?.deactiveSubs;
      state.activeSubs = action.payload?.activeSubs;
      state.thisMonthStartSubs = action.payload?.thisMonthStartSubs;
    });
    builder.addCase(GetSubscription.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(UpdateSubscriptionStatus.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(UpdateSubscriptionStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.addStatus = action.payload;
    });
    builder.addCase(UpdateSubscriptionStatus.rejected, (state, action) => {

      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(UpdateSubscriptionId.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(UpdateSubscriptionId.fulfilled, (state, action) => {
      state.loading = false;
      state.UpdateId = action.payload;
    });
    builder.addCase(UpdateSubscriptionId.rejected, (state, action) => {

      state.loading = false;
      state.error = action.payload;
    });
    //  builder.addCase(GetSubscriptionInvoice.pending, (state, action) => {
    //   state.loading = true;
    // });
    // builder.addCase(GetSubscriptionInvoice.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.data = action.payload;
    // });
    // builder.addCase(GetSubscriptionInvoice.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // });
  },
});

export default SubscriptionSlice.reducer;
